module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/link-615fff9fc3fe74112e0aeabb8cdbef16.svg&quot;;"